<template>
  <div class="row tab-wrapper">
    <div class="col-2 tabs-box">
      <v-tabs
        v-model="tab"
        vertical
        hide-slider
        class="py-7 ps-7"
      >
        <!-- "All" tab -->
        <v-tab
          :key="null"
          :disabled="false"
          :class="['tab-button', { 'tab-active': categoryKey == null }]"
          @click="notifyParent(null)"
        >
          <span class="mr-1">{{ local.home.tabCommon.all }}</span>
        </v-tab>

        <!-- Dynamic tabs -->
        <template v-for="tabButton in subRequestCategories">
          <v-tab
            :key="tabButton.id"
            :disabled="tabButton.isDisabled"
            :class="['tab-button', { 'tab-active': tabButton.objectKey == categoryKey }]"
            @click="notifyParent(tabButton.objectKey)"
          >
            <span class="mr-1">
              {{ tabButton.name }}
              <span class="green-text">({{ tabButton.count }})</span>
            </span>
          </v-tab>
        </template>
      </v-tabs>
    </div>
    <div class="col-10 tabs-box tab-box-content">
      <div class="white">
        <div
          v-show="$vuetify.breakpoint.lgAndUp"
          class="pr-16 head"
        >
          {{ local.bankruptcy.subRequests.subRequest }}
        </div>
        <v-tabs-items
          v-model="tab"
          class="mr-4 mb-1"
        >
          <slot />
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonCategory',
  props: {
    categoryKey: {
      type: [String, Number, Object],
      default: '',
    },
    subRequestCategories: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tab: {},
      selectedTab: null,
    };
  },
  methods: {
    notifyParent(objectKey) {
      this.selectedTab = objectKey;
      this.$emit('selected-category', objectKey);
    },
  },
};
</script>

<style scoped lang="scss">
.tab-button:hover {
  background-color:var(--app-primary-color)!important;
  border-radius: 8px;
  color: white !important;
  .green-text{
    color: white !important;
  }
}
.green-text {
  color: var(--app-primary-color);
  font-weight: bold;
}
.tab-box-content {
  padding: 28px !important;
}
.tabs-box {
  padding: 0px;
  background-color: #faf9f4;

  .tab-button {
    font: normal normal normal 16px/24px Almarai;
    justify-content: right;
    width: 100% !important;
    min-height: 50px;
    transition: all 0.3s ease;
    position: relative;

    &.tab-active {
      font-weight: bold;
      color: var(--app-primary-color);
    }
  }
}
.v-tab {
  background: #faf9f4 !important;
  width: 100% !important;
  max-width: 100% !important;
  flex: 1 !important;
}

::v-deep .v-tabs__bar {
  background: transparent !important;
}

::v-deep .v-tabs__wrapper {
  background: transparent !important;
}

::v-deep .List__empty {
  margin-top: 0px !important;
}

::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

.filter-row-wrapper {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 30px #d1d5df80;
}

::v-deep .info-item-details.requestCode-header {
  .info-item-details-value {
    font-size: 24px;
  }
}
.head {
  margin-top: 15px;
  margin-bottom: 20px;

  font-weight: bold;
  font-size: 1.3rem;
}
::v-deep .tab-active {
  font-weight: bold;
  background-color: #29af5b !important;
  color: white !important;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(41, 175, 91, 0.3);
  margin: 2px 0;

  .tab-button-icon {
    color: white !important;
  }

  .green-text {
    color: white !important;
  }
}
::v-deep .v-tab.tab-active {
  background-color: #29af5b !important;
  color: white !important;

  .v-tab__content {
    color: white !important;
  }

  .green-text {
    color: white !important;
  }
}
::v-deep .v-tab.tab-button.tab-active {
  background-color: var(--app-primary-color) !important;
  color: white !important;

  .v-tab__content {
    color: white !important;
  }

  .green-text {
    color: white !important;
  }
}

.info-item-box {
  display: flex;
  justify-content: space-between;
  flex: 1;
  height: 100%;
}
.white {
  border: 1px solid rgb(225, 217, 217) !important;
  border-radius: 2px;
  min-height: 270px;
}
.info-item-details-title {
  font-size: 14px;
}

.info-item-details-value {
  font-weight: bold;
  font-size: 16px;
}
.request-item-table {
  padding: 13px;
}
.tab-wrapper {
  margin-left: -23px;
  margin-right: 0px;
}
</style>
